import { useForwardingTabContext } from "@/features/maintenance/features/workflows/hooks/forwardings/useForwardingTabContext";
import TransportAutoEntriesComplete from "../../CheckinEntry/Transport/AutoEntries/Complete";

const CompleteCheckoutEntry = () => {
  const { forwarding } = useForwardingTabContext();

  if (!forwarding?.checkout_entry) return null;

  return (
    <TransportAutoEntriesComplete
      checkinEntry={forwarding.checkout_entry}
      checkType="out"
    />
  );
}

export default CompleteCheckoutEntry;
